import { render, staticRenderFns } from "./DefaultManage.vue?vue&type=template&id=531ed894&scoped=true"
import script from "./DefaultManage.vue?vue&type=script&lang=js"
export * from "./DefaultManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531ed894",
  null
  
)

export default component.exports